<script setup lang="ts">
import { useGamesStore } from '~/stores/GamesStore'
import type { SectionGameListRecord } from '~/types/datocms'

interface GamesPageFilterProps {
  categories: SectionGameListRecord['categories']
  allGamesLabel?: string
  allGamesCountLabel?: string
  invertColors?: boolean
}

withDefaults(defineProps<GamesPageFilterProps>(), {
  allGamesLabel: 'All games',
  allGamesCountLabel: 'Count:',
  invertColors: false
})

const store = useGamesStore()
const route = useRoute()

const isShowAllGames = computed(() => (Object.keys(route.query).length === 0 ? true : false))
</script>

<template>
  <div class="mb-2 flex items-center border-[#D5D5D5] pb-4 lg:mb-10 lg:border-b lg:pb-10">
    <div data-lenis-prevent class="flex overflow-scroll lg:gap-10">
      <GamesPageFilterItem
        :to="route.path"
        :is-active="isShowAllGames"
        :is-disabled="store.isLoading"
        :invert-colors="invertColors"
      >
        {{ allGamesLabel }}</GamesPageFilterItem
      >
      <GamesPageFilterItem
        v-for="category in categories"
        :key="category.slug"
        :to="{ path: route.path, query: { category: category.slug ?? '' } }"
        :is-active="route.query.category === category.slug"
        :is-disabled="store.isLoading"
        :invert-colors="invertColors"
        >{{ category.name }}</GamesPageFilterItem
      >
    </div>
  </div>
</template>
